import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";

export const NoInfoCell: FC = () => {
  const { t } = useTranslations();
  return (
    <span className="text-sm text-grey-700">
      {t({
        id: "cpanel-page.not-registered",
        defaultMessage: "No info",
      })}
    </span>
  );
};
